// Ubicación en el repo: src/components/DeletePatientDialog.jsx
// Confirmación reforzada para eliminar un paciente CON historial clínico
// (DECISIONS.md #19) — solo se muestra a un Admin; para cualquier otro rol
// el intento ya se bloqueó antes de llegar acá (ver Patients.jsx). No es
// el `confirm()` genérico: exige leer el resumen y marcar el checkbox
// antes de habilitar el botón de eliminar.
import { useState } from 'react';
import { formatPatientName } from '../lib/format';

export default function DeletePatientDialog({ patient, onCancel, onConfirm, loading }) {
  const [checked, setChecked] = useState(false);

  return (
    <div className="modal-overlay">
      <div className="modal-card">
        <h2>Eliminar paciente con historial clínico</h2>
        <p>
          <strong>{formatPatientName(patient)}</strong> tiene historial asociado. Al eliminarlo,
          el paciente y todo su historial dejan de ser visibles/operables para el resto del
          sistema — queda archivado (no se borra), y solo un Admin puede restaurarlo más
          adelante.
        </p>
        <ul className="delete-summary">
          <li>{patient.appointments_count} cita(s)</li>
          <li>{patient.exams_count} audiometría(s)</li>
          <li>{patient.prescriptions_count} receta(s) de lentes</li>
          <li>{patient.hearingaids_count} venta(s) de audífono</li>
          <li>{patient.oftsales_count} venta(s) OFT</li>
        </ul>
        <label className="field field--checkbox">
          <input
            type="checkbox"
            checked={checked}
            onChange={(e) => setChecked(e.target.checked)}
          />
          <span>
            Entiendo que este paciente tiene historial clínico asociado y confirmo la
            eliminación.
          </span>
        </label>
        <div className="modal-actions">
          <button type="button" className="button-secondary" onClick={onCancel} disabled={loading}>
            Cancelar
          </button>
          <button
            type="button"
            className="button-danger"
            disabled={!checked || loading}
            onClick={onConfirm}
          >
            {loading ? 'Eliminando…' : 'Eliminar paciente'}
          </button>
        </div>
      </div>
    </div>
  );
}
